import { Grid, Box, Skeleton } from "@mui/material";


export default function BoardSkeleton() {
    return (
        <Grid container spacing={3}>
            {Array.from({ length: 3 }).map((_, i) => (
                <Grid item xs={12} md={4} key={i}>
                    <Box
                        sx={{
                            border: 1,
                            borderColor: "divider",
                            borderRadius: 2,
                            p: 2,
                        }}
                    >
                        <Skeleton variant="rectangular" width={128} height={32} sx={{ mb: 2 }} />
                        {Array.from({ length: 3 }).map((_, j) => (
                            <Skeleton
                                key={j}
                                variant="rectangular"
                                height={128}
                                sx={{ width: "100%", mb: 1.5, borderRadius: 2 }}
                            />
                        ))}
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
}